module.exports = __webpack_public_path__ + "static/media/icon_78.5b99749b.svg";